"use client";

import { Briefcase, Code, Layers, Lightbulb, Settings, Smartphone, TrendingUp, Users } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const categories = [{
  id: 1,
  icon: Briefcase,
  title: "Business"
}, {
  id: 2,
  icon: Code,
  title: "Development"
}, {
  id: 3,
  icon: Layers,
  title: "Design"
}, {
  id: 4,
  icon: Lightbulb,
  title: "Consulting"
}, {
  id: 5,
  icon: TrendingUp,
  title: "Marketing"
}];
const services = [{
  id: 1,
  icon: Smartphone,
  name: "Mobile Apps",
  description: "Native and cross-platform mobile application development"
}, {
  id: 2,
  icon: Code,
  name: "Web Development",
  description: "Custom web solutions built with modern technologies"
}, {
  id: 3,
  icon: Layers,
  name: "UI/UX Design",
  description: "User-centered design for digital products"
}, {
  id: 4,
  icon: Settings,
  name: "API Integration",
  description: "Seamless integration with third-party services"
}, {
  id: 5,
  icon: Users,
  name: "Team Augmentation",
  description: "Skilled developers to extend your team"
}, {
  id: 6,
  icon: Lightbulb,
  name: "Strategy",
  description: "Technical consulting and product roadmaps"
}, {
  id: 7,
  icon: TrendingUp,
  name: "Analytics",
  description: "Data-driven insights and reporting solutions"
}, {
  id: 8,
  icon: Briefcase,
  name: "Enterprise",
  description: "Large-scale solutions for complex business needs"
}];
export default function OurServices() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="our-services" ref={ref} className="bg-dark-background text-foreground-dark py-16 px-4 md:px-8">
      <div className="mx-auto max-w-7xl">
        <h2 className="font-display mb-12 text-center text-3xl font-bold md:text-4xl">
          Our Services
        </h2>

        <div className="flex flex-col gap-8 lg:flex-row">
          {}
          <div className="flex flex-row flex-wrap justify-center gap-4 lg:w-[30%] lg:flex-col lg:justify-start">
            {categories.map((category, i) => {
            const Icon = category.icon;
            return <div key={category.id} data-index={i} className={`group flex items-center gap-3 transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] ${isVisible ? "animate-fade-in-up" : "translate-y-4 opacity-0"}`} style={{
              animationDelay: `${i * 80}ms`
            }}>
                  <div className="flex size-12 items-center justify-center rounded-full bg-secondary/20 transition-all duration-200 ease-[var(--ease-out-back)] hover:-translate-y-0.5 hover:bg-secondary/30 hover:shadow-medium">
                    <Icon className="size-6 stroke-primary stroke-[1.5]" />
                  </div>
                  <span className="text-sm font-medium opacity-0 transition-opacity duration-200 group-hover:opacity-100">
                    {category.title}
                  </span>
                </div>;
          })}
          </div>

          {}
          <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:w-[70%]">
            {services.map((service, i) => {
            const Icon = service.icon;
            return <div key={service.id} data-index={i} className={`group rounded-lg bg-dark-background border border-border p-6 shadow-soft transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)] hover:-translate-y-0.5 hover:bg-[hsl(220,20%,28%)] hover:shadow-medium ${isVisible ? "animate-fade-in-up" : "translate-y-4 opacity-0"}`} style={{
              animationDelay: `${i * 80}ms`
            }}>
                  <Icon className="mb-4 size-8 stroke-primary" />
                  <h3 className="mb-2 font-display text-lg font-semibold text-accent-dark">
                    {service.name}
                  </h3>
                  <p className="text-sm text-foreground leading-relaxed">
                    {service.description}
                  </p>
                </div>;
          })}
          </div>
        </div>
      </div>
    </section>;
}